import React, { useState } from "react";
import { Container } from "./style";
import { getUserNameWithMobile } from "../../assets/getUserIdentification";
import Button from "../../components/button";
import { ProjectAction } from "../../actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  CONFIRM_OK_BUTTON_TEXT,
  CONFIRM_REJECT_BUTTON_TEXT,
  INVITATION_TO_PROJECT_WITH_ROLE_TEXT
} from "../../constants/otherTexts";
import { PROJECT_USER_STATE } from "../../constants/projectUser";
import { getRoles } from "../../assets/getRoles";
import { Confirm } from "../../components/confirm";

const ACCEPT = 1;
const REJECT = 2;

const Index = props => {
  const { processing, answerInvitation, project, bigSize, setConfirm, confirmInfo } = props;
  // const [confirm, toggleConfirm] = useState(false);
  const [pressed, setPressed] = useState(0);
  const onClickHandle = type => {
    const ansIsAccept = type === ACCEPT;
    answerInvitation(project.id, ansIsAccept);
    setPressed(type);
  };
  const getLoading = type => {
    return pressed === type && processing;
  };

  const roles = () => {
    const projectUsers = project.project_users;
    let roles = projectUsers
      .filter(projectUser => projectUser.state === PROJECT_USER_STATE.PENDING)
      .map(projectUser => projectUser.user_type);
    const rolesSet = new Set(roles);
    roles = Array.from(rolesSet);
    return getRoles(roles, "،", " و");
  };

  const closeConfirm = () => {
    setConfirm();
  };
  const showConfirm = () => {
    setConfirm({
      show: true,
      title: "رد دعوت‌نامه",
      message:
          "آیا از رد این دعوت‌نامه مطمئن هستید؟",
      action: () => answerInvitation(project.id, false)
    });
  };
  return (
    <React.Fragment>
      <Confirm
        show={confirmInfo.show}
        rejectHandler={() => closeConfirm()}
        close={() => closeConfirm()}
        acceptHandler={confirmInfo.action}
        content={{
          type: "danger",
          title: confirmInfo.title,
          message: confirmInfo.message,
          acceptButtonText: CONFIRM_OK_BUTTON_TEXT,
          rejectButtonText: CONFIRM_REJECT_BUTTON_TEXT
        }}
        loading={processing}
      />
      <Container bigSize={bigSize}>
        <i className="icon-part icon mapsa-invite" />
        <div className="main-part">
          <div className="invitation-text">
            {INVITATION_TO_PROJECT_WITH_ROLE_TEXT(project.name, roles())}
          </div>
          <div className="owner-text">
            <i className="icon mapsa-manager" />
            <span>مالک شرکت: {getUserNameWithMobile(project.owner)}</span>
          </div>
          <div className="actions-wrapper">
            <Button
              btn="primary"
              onClick={() => onClickHandle(ACCEPT)}
              loading={getLoading(ACCEPT)}
            >
              قبول دعوت
            </Button>
            <Button
              btn="outline-error"
              onClick={() => showConfirm()}
              disabled={pressed === ACCEPT && processing}
            >
              رد دعوت
            </Button>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

const mapStateToProps = store => {
  return {
    processing: store.Project.invitationProcessing,
    confirmInfo: store.Project.confirmInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    answerInvitation: (projectId, ansIsAccept) => {
      dispatch(ProjectAction.answerInvitation(projectId, ansIsAccept));
    },
    setConfirm: info => {
      dispatch(ProjectAction.setConfirmInfo(info));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Index));
